module.exports = __webpack_public_path__ + "img/_add_person.8c4bd114.svg";